import React from 'react';
import Email from '../assets/images/emailicon.svg';

export default () => {
  return <img src={Email} alt="" />;
};
